/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Plugins

import { registerPlugins } from '@/plugins'
import { createApp } from 'vue'

// Components
import App from './App.vue'

const app = createApp(App)
registerPlugins(app)

app.mount('#app')
